import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum EmployeesScheduledFilterEnum {
    AllEmployeess = 0,
    Assigned = 1,
    Unassigned = 2
}

export class EmployeesScheduledFilterClass extends EnumWithDescription<EmployeesScheduledFilterEnum> {
    public readonly enum = EmployeesScheduledFilterEnum;
    public readonly enumName: string = "EmployeesScheduledFilterEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<EmployeesScheduledFilterEnum>> = new Map([
        [
            "AllEmployeess",
            {
                value: EmployeesScheduledFilterEnum.AllEmployeess,
                name: "All Schedule Types"
            }
        ],
        [
            "Assigned",
            {
                value: EmployeesScheduledFilterEnum.Assigned,
                name: "Assigned"
            }
        ],
        [
            "Unassigned",
            {
                value: EmployeesScheduledFilterEnum.Unassigned,
                name: "Unassigned"
            }
        ]
    ]);
}

export const EmployeesScheduledFilter = new EmployeesScheduledFilterClass();
